import React, { Component } from 'react';
import { TweenMax } from 'gsap';

import style from './PlayPauseButton.module.scss';

let MorphSVG;

class PlayPauseButton extends Component {
  componentDidMount() {
    if (typeof window !== 'undefined') {
      MorphSVG = require('../../lib/MorphSVG');
    }

    // Play/Pause button animation
    this.playPauseAnim = new TimelineMax({
      paused: true,
    });

    this.playPauseAnim
      .to(this.playPauseLeft, 0.3, {
        x: 2.2,
        morphSVG: '7.5,12.9 7.5,12.9 0,17 0,8.5 0,0 7.5,4.2 7.5,4.2 7.5,8.5',
        ease: Cubic.easeInOut,
      })
      .to(
        this.playPauseRight,
        0.3,
        {
          x: 2,
          morphSVG:
            '15,8.5 7.5,12.9 7.5,12.9 7.5,8.5 7.5,4.2 7.5,4.2 15,8.5 15,8.5',
          ease: Cubic.easeInOut,
        },
        '-=0.3'
      );

    if (
      this.props.isVideoPaused ||
      this.props.isAudioPaused ||
      this.props.isPaused
    ) {
      this.playPauseAnim.progress(1);
    }
  }

  componentWillReceiveProps(nextProps) {
    // Play/Pause Button Animation
    if (
      this.props.isVideoPaused !== nextProps.isVideoPaused ||
      this.props.isAudioPaused !== nextProps.isAudioPaused ||
      this.props.isPaused !== nextProps.isPaused
    ) {
      if (
        nextProps.isVideoPaused ||
        nextProps.isAudioPaused ||
        nextProps.isPaused
      ) {
        this.playPauseAnim.play();
      } else {
        this.playPauseAnim.reverse();
      }
    }
  }

  render() {
    return (
      <button
        className={`play-pause-button ${style.playPauseButton} ${
          !this.props.noBorder ? style.playPauseBorder : ''
        } ${
          !this.props.noBackground
            ? 'play-pause-bg ' + style.playPauseBackground
            : ''
        } ${this.props.largeButton ? style.playPauseLarge : ''} ${
          this.props.colorTheme ? style['color-' + this.props.colorTheme] : ''
        }`}
        onClick={this.props.onPlayPauseClick}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="17"
          viewBox="0 0 15 17"
          overflow="visible"
        >
          <title>Play/Pause Button</title>

          <polygon
            ref={el => (this.playPauseLeft = el)}
            points="5,17 2.5,17 0,17 0,8.5 0,0 2.5,0 5,0 5,8.5 "
          />
          <polygon
            ref={el => (this.playPauseRight = el)}
            points="15,17 12.5,17 10,17 10,8.5 10,0 12.5,0 15,0 15,8.5 "
          />
          {!this.props.noBorder && (
            <circle
              stroke="white"
              strokeWidth="2"
              fill="none"
              cx="50%"
              cy="50%"
              r="135%"
            />
          )}
        </svg>
      </button>
    );
  }
}

export default PlayPauseButton;



// WEBPACK FOOTER //
// ./src/components/ui/PlayPauseButton.js